module.exports = __webpack_public_path__ + "static/media/inventory.41b3235e.svg";